export const categoryColumnOptions = [
  {
    field: "Référence",
    description: "Identifiant unique pour la catégorie",
    example: "CAT001, CAT002, REF-ABC",
    required: true,
    category: "basic",
  },
  {
    field: "Nom",
    description: "Nom de la catégorie",
    example: "Services informatiques, Matériel de bureau, Consulting",
    required: true,
    category: "basic",
  },
  {
    field: "Description",
    description: "Description détaillée de la catégorie",
    example: "Catégorie pour tous les services IT, Fournitures de bureau",
    required: false,
    category: "basic",
  },
];
